export const IndicatorActionTypes = {
  FETCH_ROOMS_INDICATORS: 'FETCH_ROOMS_INDICATORS',
  FETCH_USERS_INDICATORS: 'FETCH_USERS_INDICATORS',
  FETCH_TICKETS_INDICATORS: 'FETCH_TICKETS_INDICATORS',
  FETCH_TICKETS_USERS_INDICATORS: 'FETCH_TICKETS_USERS_INDICATORS',
  FETCH_TEAM_INDICATORS: 'FETCH_TEAM_INDICATORS',
};